import type { Worksite } from "@/adapters/api";
import type { Canteiro } from "./types.ts";

export function toCanteiro(w: Worksite): Canteiro {
	return {
		id: w.id,
		slug: w.slug,
		name: w.name,
		status: w.status,
		description: w.description || undefined,
		city: w.address?.city || undefined,
		state: w.address?.state || undefined,
		coverImageUrl: w.cover_image_url || undefined,
		startDate: w.start_date,
		expectedEndDate: w.expected_end_date,
	};
}

export function canteiroUrlKey(canteiro: Canteiro): string {
	return canteiro.slug ?? canteiro.id;
}

export function resolveCanteiro(
	canteiros: Canteiro[],
	value: string | null | undefined,
): Canteiro | undefined {
	if (!value) return undefined;
	return canteiros.find((c) => c.id === value || c.slug === value);
}

export function canteiroLocation(canteiro: Canteiro): string {
	return [canteiro.city, canteiro.state].filter(Boolean).join(" · ");
}

const ACCENT_COUNT = 6;

export function canteiroAccent(id: string): string {
	let hash = 0;
	for (let i = 0; i < id.length; i++) {
		hash = (hash * 31 + id.charCodeAt(i)) | 0;
	}
	const index = Math.abs(hash) % ACCENT_COUNT;
	return String(index + 1);
}
